import { PresenceStatusRemoteDto } from '../../../../../generated/signalR/presence-status-remote-dto';

export class PresenceStatusValuesUpdated {
   public static readonly type = '[PresenceStatus] Presence status values Updated';

   constructor(public presenceStates: PresenceStatusRemoteDto[]) {}
}
